import {Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {FormShell} from '@/components';
import {useFatcaCrsForm} from '@/features/trust-accounts/activation/packages/compliance/hooks';
import {isFatcaCrsDeclarationSigned} from '@/features/trust-accounts/fatca-crs';

import {FatcaCrsConditionsSection} from './FatcaCrsConditionsSection';
import {FatcaCrsConsentsSection} from './FatcaCrsConsentsSection';

import type {FormStateSnapshot} from '@/hooks';
import type {FatcaCrsDeclarationDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface FatcaCrsDeclarationStepFormProps {
  trustAccountId: string;
  declaration: FatcaCrsDeclarationDTO | null | undefined;
  isLoading: boolean;
  isError: boolean;
  projectName?: string;
  lawyerName?: string;
  onFormStateChange?: (state: FormStateSnapshot) => void;
}

export const FatcaCrsDeclarationStepForm: FC<FatcaCrsDeclarationStepFormProps> = ({
  trustAccountId,
  declaration,
  isLoading,
  isError,
  projectName,
  lawyerName,
  onFormStateChange
}) => {
  const {t} = useTranslation('trustAccounts');
  const {form, handleSave, saveError} = useFatcaCrsForm({
    trustAccountId,
    declaration,
    isLoading,
    isError,
    onFormStateChange
  });
  const {control, setValue} = form;
  const isSigned = isFatcaCrsDeclarationSigned(declaration?.status);

  return (
    <FormShell
      id="fatca-crs-declaration-form"
      className="flex flex-col gap-6"
      onSubmit={handleSave}
      saveError={saveError}
    >
      <Typography as="h2" size="xl" weight="semibold">
        {t('activation.packages.compliance.fatcaCrs.title', {projectName: projectName ?? ''})}
      </Typography>
      <FatcaCrsConditionsSection control={control} setValue={setValue} disabled={isSigned} />
      <FatcaCrsConsentsSection control={control} lawyerName={lawyerName} disabled={isSigned} />
    </FormShell>
  );
};
